import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LoadingSkeletonDirective2 } from 'common-ui';
import { ProductComponentBase } from '../../../ProductComponentBase';

@Component({
  selector: 'ideal-product-short-description',
  imports: [LoadingSkeletonDirective2],
  templateUrl: './product-short-description.component.html',
  styleUrl: './product-short-description.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  host: {
    '[style.--max-lines]': 'maxLines() ?? 0',
    '[attr.line]': '(maxLines() ?? 0) > 0 ? "" : null',
  },
})
export class ProductShortDescriptionComponent extends ProductComponentBase {
  public readonly maxLines = input<number>(0);
}
